export const formatStoreName = (storeName:string) : string => {

    if(!storeName) return ''

    let res = storeName.substring(0,2);

    for(let i=2;i<storeName.length;i++){
        res += ' _ '
    }


    return res
}

export const formatProductName = (productName: string, storeName: string): string => {

    if(!storeName || !productName) return ''

    let formattedName = productName;
    
    // 상점 이름을 "*_*"로 치환
    if (formattedName.includes(storeName)) {
        const replacement =  '_ '.repeat(storeName.length);
    formattedName = formattedName.replace(storeName, replacement);
      
    }
    
    // 10글자로 자르기
    return formattedName.length > 20 ? formattedName.slice(0, 20) + ' ...' : formattedName;
  }